__turbopack_context__.v({
  "slider": "REjh5q_slider",
});
